import { availabilityApi, bookingApi, contentApi } from '@/infrastructure/Configuration'
import { getPageLanguage, isTaxIncludedRegion } from '@/infrastructure/Utils'

export default class BookingSumarryService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getBookingDetails(bookingHeaderInfo) {
    const url = `${bookingApi}/booking`
    bookingHeaderInfo.taxIncludedRegion = isTaxIncludedRegion()
    const { data } = await this.httpClient.post(url, bookingHeaderInfo)
    return data
  }

  async getHotelDetails(hotelCode, tier = null) {
    const url = `${contentApi}/hotels/${hotelCode}/booking-summary`
    const { data } = await this.httpClient.get(url, tier ? { params: { tier } } : null)
    return data
  }

  async modifyBooking(bookingInfo) {
    const transactionId = sessionStorage.getItem('transactionId')

    const config = {
      headers: {
        'Accept-Language': getPageLanguage(),
        transactionId
      }
    }
    const url = `${bookingApi}/modify`
    const { data } = await this.httpClient.post(url, bookingInfo, config)
    return data
  }

  async applyVoucher(bookingId, data) {
    const response = await this.httpClient.post(`${bookingApi}/${bookingId}/apply-voucher`, data)
    return response.data
  }

  async getPaymentGetwayInfo(bookingHeaderInfo) {
    const transactionId = sessionStorage.getItem('transactionId')

    const config = {
      headers: {
        'Accept-Language': getPageLanguage(),
        transactionId
      }
    }
    const response = await this.httpClient.post(
      `${bookingApi}/booking/pay`,
      bookingHeaderInfo,
      config
    )
    return response.data
  }

  async getQrImage(qrCode) {
    const transactionId = sessionStorage.getItem('transactionId')
    const config = {
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        transactionId
      },
      responseType: 'blob'
    }
    const url = `/view-qr?data=${qrCode}`
    const { data } = await this.httpClient.get(url, config)
    return URL.createObjectURL(data)
  }

  async getExchangeRates(currency) {
    const url = `${availabilityApi}/exchange-rates/${currency}`
    const { data } = await this.httpClient.get(url)
    return data
  }

  async requestPassbook(bookingInfo) {
    const url = `${contentApi}/passbook`
    const { data } = await this.httpClient.post(url, bookingInfo, {
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
    return data
  }
}
